import React from 'react';
import { Modal } from '@/components/ui/Modal';
import { EmailLogin } from './EmailLogin';
import { OAuthDisclosure } from './OAuthDisclosure';

interface EmailLoginModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const EmailLoginModal: React.FC<EmailLoginModalProps> = ({ isOpen, onClose }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} title="כניסה עם אימייל">
            <div className="flex flex-col gap-4">
                <EmailLogin />
                <OAuthDisclosure />
            </div>
        </Modal>
    );
};
